'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails from "./presto.types$-Morbid-User-Details.js";
var $p;
/** @constructor */
function $c_Lpresto_types$MorbidUserDetails$() {
}
export { $c_Lpresto_types$MorbidUserDetails$ as $c_Lpresto_types$MorbidUserDetails$ };
$p = $c_Lpresto_types$MorbidUserDetails$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$MorbidUserDetails$;
/** @constructor */
function $h_Lpresto_types$MorbidUserDetails$() {
}
export { $h_Lpresto_types$MorbidUserDetails$ as $h_Lpresto_types$MorbidUserDetails$ };
$h_Lpresto_types$MorbidUserDetails$.prototype = $p;
$p.l = (function() {
  return "MorbidUserDetails";
});
$p.Gp = (function(x$0) {
  return new $j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails.$c_Lpresto_types$MorbidUserDetails(x$0.j(0), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(1)));
});
var $d_Lpresto_types$MorbidUserDetails$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$MorbidUserDetails$, "presto.types$MorbidUserDetails$", ({
  a11: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$MorbidUserDetails$ as $d_Lpresto_types$MorbidUserDetails$ };
var $n_Lpresto_types$MorbidUserDetails$;
function $m_Lpresto_types$MorbidUserDetails$() {
  if ((!$n_Lpresto_types$MorbidUserDetails$)) {
    $n_Lpresto_types$MorbidUserDetails$ = new $c_Lpresto_types$MorbidUserDetails$();
  }
  return $n_Lpresto_types$MorbidUserDetails$;
}
export { $m_Lpresto_types$MorbidUserDetails$ as $m_Lpresto_types$MorbidUserDetails$ };
//# sourceMappingURL=presto.types$-Morbid-User-Details$.js.map
